import { render } from "./SliderTabs.vue?vue&type=template&id=b217908a&scoped=true"
import script from "./SliderTabs.vue?vue&type=script&lang=js"
export * from "./SliderTabs.vue?vue&type=script&lang=js"

import "@/Common/Styles/sliderTabs.scss?vue&type=style&index=0&id=b217908a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b217908a"]])

export default __exports__